import styles from "./ShowItem.module.css";
import tempImage from "../../../../assets/tempIMG1.jpg";
import { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import CartContext from "../../../store/cart-context";

export default function ShowItem({ item }) {
  const [loaded, setLoaded] = useState(false);
  const cartCtx = useContext(CartContext);
  const navigate = useNavigate();

  const openItem = () => {
    navigate(`${item.slug}`, {
      state: { item: item },
    });
  };

  const onReserveHandler = (e) => {
    e.stopPropagation();
    cartCtx.addItem([item]);
  };

  return (
    <main onClick={openItem} className={styles.main}>
      <div
        className={`${styles[loaded && `container-loaded`]} ${
          styles.container
        }`}
      >
        <div
          className={`${styles.add} ${
            cartCtx?.items?.length > 0 &&
            cartCtx.items.find((e) => (e.id = item.id))?.quantity >=
              item.stock_quantity &&
            styles[`add-disabled`]
          }`}
          onClick={
            cartCtx?.items?.length > 0 &&
            cartCtx.items.find((e) => (e.id = item.id))?.quantity >=
              item.stock_quantity
              ? () => {}
              : onReserveHandler
          }
        >
          +
        </div>
        <div className={styles[`image-container`]}>
          <img
            src={item.featured_image || tempImage}
            onLoad={() => {
              setLoaded(true);
            }}
            className={styles.image}
          />
          <img
            src={
              item.images && item.images.length > 0
                ? item.images[item.images.length - 1]
                : tempImage
            }
            className={styles[`hover-image`]}
          />
        </div>
        <div className={styles.title}>{item.name}</div>
      </div>
    </main>
  );
}
